import React from 'react';
import classnames from 'classnames/bind';
import { SideDrawer as ExternalSideDrawer, useIsMobile } from 'taboola-ultimate-ui';
import { ANCHOR_DIRECTIONS, DRAWER_MODE } from 'components/SideDrawer/SideDrawer';
import styles from './sideDrawer.module.scss';

const classNameBuilder = classnames.bind(styles);

export const SideDrawer = ({
    path: _path,
    drawerMode,
    pop,
    index,
    openDrawer,
    calculatedWidth: _calculatedWidth,
    rightOffset: _rightOffset,
    fullScreenMode: _fullScreenMode,
    stackLength: _stackLength,
    layerCount: _layerCount,
    children,
    layerStyle,
    ...restProps
}) => {
    const isMobile = useIsMobile();
    const containerClassName = classNameBuilder({
        'remove-animation': index === 0 && drawerMode === DRAWER_MODE.LARGE,
    });

    const sideDrawerZIndex = parseInt(styles.sideDrawerLayer) + index;

    return (
        <ExternalSideDrawer
            anchorDirection={ANCHOR_DIRECTIONS.RIGHT}
            openDrawer={openDrawer}
            fitToScreen={isMobile}
            style={{
                ...layerStyle,
                zIndex: sideDrawerZIndex,
            }}
            onClose={pop}
            containerClassName={containerClassName}
            overlayStyle={{ zIndex: sideDrawerZIndex - 1 }}
            {...restProps}
        >
            {children}
        </ExternalSideDrawer>
    );
};
